import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { TaskDuration } from "../../models";
import { RQ } from "../../globals/enums";
import { remove } from "../../api/generic-api";
import { deleteEntity } from "../../utils";

export const useDeleteTaskDuration = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("task-durations", id), {
    onSuccess: (_, id) => {
      enqueueSnackbar("Task Duration Deleted", { variant: "success" });
      queryClient.setQueryData(
        RQ.TASK_DURATIONS,
        (taskDurations: TaskDuration[] | undefined) => {
          return !taskDurations
            ? []
            : deleteEntity<TaskDuration>(taskDurations, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Task Duration Deleting Error", { variant: "error" });
    },
  });
};
